export default theme => ({
    wrapper: {
        fontSize: 12,
        padding: '5px 12px',
        fontWeight: 700,
        borderRadius: 55,
        textTransform: 'capitalize',
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[900],
        maxHeight: 24,
        lineHeight: 1.1,
        display: 'inline-block'
    },
    hoveredWrapper: {
        color: theme.palette.grey[600]
    },
    loader: {
        color: theme.palette.grey[900]
    }
});
